import VenoBox from 'venobox'

// get current slide
const currentSlide = document.querySelector('.swiper-testimonial-slider-content .swiper-slide-active');

// get elements
const coverImage = currentSlide?.querySelector('.cover-image');
const slideClose = currentSlide?.querySelector('.slide-close');
const navigation = document.querySelector('.navigation');
const sliderGradient = document.querySelector('.slider-gradient');

// // when slide is opened, hide navigation and slider gradient
// if (coverImage) {
//     coverImage.addEventListener('click', function() {
//         console.log('slide opened');
//         coverImage.classList.add('opacity-0');
//         navigation.classList.add('opacity-0');
//         sliderGradient.classList.add('opacity-0');
//     });
// }
// // when slide is closed, show navigation and slider gradient
// if (slideClose) {
//     slideClose.addEventListener('click', function() {
//         console.log('slide closed');
//         coverImage.classList.remove('hidden');
//         navigation.classList.remove('hidden');
//         sliderGradient.classList.remove('hidden');
//     });
// }

export default function() {
	let inlinePopup = new VenoBox({
		selector: '.inline-popup',
		customClass: 'twk-inline-popup',
		numeration: false,
		infinigall: false,
		share: false,
		spinner: 'pulse',
		bgcolor: 'white',
		overlayColor: 'rgb(0 39 86 / 50%)',

		onPostOpen: function(obj, gallIndex, thenext, theprev){
			//console.log(obj);
			//console.log('popup open');
			// coverImage.classList.add('opacity-0');
			if(navigation) {
				navigation.classList.add('opacity-0');
			}
			// sliderGradient.classList.add('opacity-0');
		},
		onPreClose: function(obj, gallIndex, thenext, theprev) {
			// coverImage.classList.remove('hidden');
			if(navigation) {
				navigation.classList.remove('opacity-0');
			}
			// sliderGradient.classList.remove('hidden');
		}
		/* onPostOpen: function(obj, gallIndex, thenext, theprev){
			document.querySelector( '.twk-inline-popup .vbox-close' ).style.display = 'none'

			document.querySelector( '.vbox-content .custom-close-button' ).addEventListener('click', function(){
				inlinePopup.close()
			}, false)
		}, */
	});
}